import { axiosRequest } from '@/util/axios-request';

// 官方文件—PND1列表查询
export var taxGetMonthList = function taxGetMonthList(data) {
  return axiosRequest({
    url: '/web/tax/getMonthList',
    method: 'POST',
    data: data
  });
};

// 官方文件—PND1下载Excel
export var taxExportMonth = function taxExportMonth(data) {
  return axiosRequest({
    url: '/web/tax/exportMonth',
    method: 'POST',
    data: data
  });
};

// 官方文件—PND1下载TXT
export var downloadPNDTxt = function downloadPNDTxt(data) {
  return axiosRequest({
    url: '/web/tax/exportMonthTxt',
    method: 'POST',
    data: data
  });
};

// 官方文件—PND1下载pdf
export var downloadPdf = function downloadPdf(data) {
  return axiosRequest({
    url: '/web/tax/download',
    method: 'POST',
    params: data
  });
};

// 官方文件—PND3列表查询
export var getPnd3MonthList = function getPnd3MonthList(data) {
  return axiosRequest({
    url: '/web/tax/getPnd3MonthList',
    method: 'POST',
    data: data
  });
};

// 官方文件—PND3下载TXT
export var downloadPnd3TXT = function downloadPnd3TXT(data) {
  return axiosRequest({
    url: '/web/tax/exportPnd3Txt',
    method: 'POST',
    data: data
  });
};

// 官方文件—PND3下载Excel
export var exportPnd3Excel = function exportPnd3Excel(data) {
  return axiosRequest({
    url: '/web/tax/exportPnd3Excel',
    method: 'POST',
    data: data
  });
};

// 官方文件—PND3下载pdf
export var downloadPnd3PDF = function downloadPnd3PDF(data) {
  return axiosRequest({
    url: '/web/tax/downloadPnd3',
    method: 'POST',
    data: data
  });
};

// 官方文件—PND1 Kor 列表查询
export var getKorLists = function getKorLists(data) {
  return axiosRequest({
    url: '/web/tax/getKorLists',
    method: 'POST',
    data: data
  });
};

// 官方文件—PND1 Kor Excel下载
export var exportKorExcel = function exportKorExcel(data) {
  return axiosRequest({
    url: '/web/tax/exportKorExcel',
    method: 'POST',
    data: data
  });
};

// 官方文件—PND1 Kor 下载TXT
export var downloadKorTxt = function downloadKorTxt(data) {
  return axiosRequest({
    url: '/web/tax/exportKorTxt',
    method: 'POST',
    data: data
  });
};

// 官方文件—PND1 Kor 下载pdf
export var downloadKorPdf = function downloadKorPdf(data) {
  return axiosRequest({
    url: '/web/tax/downloadKorPdf',
    method: 'POST',
    data: data
  });
};

// 官方社保文件-SorPorSor.1-10-查询
export var SocialGetMonthList = function SocialGetMonthList(data) {
  return axiosRequest({
    url: '/web/Social/getMonthList',
    method: 'POST',
    data: data
  });
};
// 官方社保文件-SorPorSor.1-10-txt导出
export var downloadMonthTxt = function downloadMonthTxt(data) {
  return axiosRequest({
    url: '/web/social/exportMonthTxt',
    method: 'POST',
    data: data
  });
};
// 官方社保文件-SorPorSor.1-10-Excel导出
export var socialExportMonth = function socialExportMonth(data) {
  return axiosRequest({
    url: '/web/Social/exportMonth',
    method: 'POST',
    data: data
  });
};
// 员工信息表
export var staffInfoList = function staffInfoList(data) {
  return axiosRequest({
    url: 'web/staff_info/getList',
    method: 'POST',
    data: data
  });
};
// 员工信息Excel
export var staffInfoExcel = function staffInfoExcel(data) {
  return axiosRequest({
    url: '/web/staff_info/export',
    method: 'POST',
    data: data
  });
};

// 员工信息Excel
export var exportMonth = function exportMonth(data) {
  return axiosRequest({
    url: '/web/provident/exportMonth',
    method: 'POST',
    data: data
  });
};

//
export var getMonthList = function getMonthList(data) {
  return axiosRequest({
    url: '/web/provident/getMonthList',
    method: 'POST',
    data: data
  });
};

// 50tawi下载pdf
export var downloadTawiPdf = function downloadTawiPdf(data) {
  return axiosRequest({
    url: '/web/Certificate/download50Tawi',
    method: 'POST',
    data: data
  });
};

// 员工证明——50Tawi 全部发送
export var send50Tawi = function send50Tawi(data) {
  return axiosRequest({
    url: '/web/Certificate/send50Tawi',
    method: 'POST',
    data: data
  });
};

// 员工证明——在职证明、工资证明、就业证明列表
export var certificateLists = function certificateLists(data) {
  return axiosRequest({
    url: '/web/Certificate/lists',
    data: data
  });
};
// 员工证明——在职证明、工资证明、就业证明发送邮件
export var certificateSend = function certificateSend(data) {
  return axiosRequest({
    url: '/web/Certificate/send',
    data: data
  });
};

// 员工证明——在职证明、工资证明、就业证明批量下载
export var certificateDown = function certificateDown(data) {
  return axiosRequest({
    url: '/web/Certificate/download',
    data: data
  });
};

// 获取员工证明类型
export var certificateInit = function certificateInit(data) {
  return axiosRequest({
    url: '/web/certificate/init',
    data: data
  });
};

// 证明下载——50tawi员工列表
export var getTawiList = function getTawiList(data) {
  return axiosRequest({
    url: '/web/Certificate/getTawiList',
    data: data
  });
};

// 证明下载——获取员工空邮箱的数量
export var countNoEmail = function countNoEmail(data) {
  return axiosRequest({
    url: '/web/Certificate/countNoEmail',
    data: data
  });
};

// 证明下载——批量发送邮件
export var sendTawiMail = function sendTawiMail(data) {
  return axiosRequest({
    url: '/web/Certificate/sendMail',
    data: data
  });
};

// 证明下载——预览
export var previewTawi = function previewTawi(data) {
  return axiosRequest({
    url: '/web/Certificate/previewTawi',
    data: data
  });
};

// 模板配置—获取证明模板配置
export var getCertificateConfig = function getCertificateConfig(data) {
  return axiosRequest({
    url: '/web/company/getCertificateConfig',
    method: 'GET',
    params: data
  });
};

// 模板配置—保存通用模板配置
export var saveBasicCertificateConfig = function saveBasicCertificateConfig(data) {
  return axiosRequest({
    url: '/web/company/saveBasicCertificateConfig',
    method: 'GET',
    params: data
  });
};

// 模板配置—保存官方文件配置
export var saveOfficialCertificateConfig = function saveOfficialCertificateConfig(data) {
  return axiosRequest({
    url: '/web/company/saveOfficialCertificateConfig',
    method: 'GET',
    params: data
  });
};

// 模板配置—保存员工模板配置
export var saveCertificateConfig = function saveCertificateConfig(data) {
  return axiosRequest({
    url: '/web/company/saveCertificateConfig',
    method: 'GET',
    params: data
  });
};

// 历史记录——列表查询
export var getHistoryList = function getHistoryList(data) {
  return axiosRequest({
    url: '/web/Certificate/certificateHistory',
    method: 'GET',
    params: data
  });
};

// 定时任务—新建定时任务
export var addCertificateTask = function addCertificateTask(data) {
  return axiosRequest({
    url: '/web/Certificate/addTask',
    method: 'GET',
    params: data
  });
};

// 定时任务—编辑定时任务
export var editCertificateTask = function editCertificateTask(data) {
  return axiosRequest({
    url: '/web/Certificate/editTask',
    method: 'GET',
    params: data
  });
};

// 定时任务—取消定时任务
export var cancelCertificateTask = function cancelCertificateTask(data) {
  return axiosRequest({
    url: '/web/Certificate/cancelTask',
    method: 'GET',
    params: data
  });
};

// 定时任务——列表查询
export var getCertificateList = function getCertificateList(data) {
  return axiosRequest({
    url: '/web/Certificate/taskList',
    method: 'GET',
    params: data
  });
};

// 定时任务——任务详情
export var infoCertificateTask = function infoCertificateTask(data) {
  return axiosRequest({
    url: '/web/Certificate/taskInfo',
    method: 'GET',
    params: data
  });
};

// 定时任务——发送记录列表查询
export var sendCertificateTask = function sendCertificateTask(data) {
  return axiosRequest({
    url: '/web/Certificate/taskSendList',
    method: 'GET',
    params: data
  });
};

// 定时任务—重新发送失败记录
export var retryCertificateTask = function retryCertificateTask(data) {
  return axiosRequest({
    url: '/web/Certificate/retrySendFailTask',
    method: 'GET',
    params: data
  });
};

// 定时任务—检测任务名是否重复
export var existTaskName = function existTaskName(data) {
  return axiosRequest({
    url: '/web/Certificate/existTaskName',
    method: 'GET',
    params: data
  });
};

// 员工证明—获取任务发送记录失败数量
export var getTaskFailTotal = function getTaskFailTotal(data) {
  return axiosRequest({
    url: '/web/Certificate/getTaskFailTotal',
    method: 'GET',
    params: data
  });
};
export var downloadList = function downloadList(data) {
  return axiosRequest({
    url: '/web/Certificate/getTaskFailTotal',
    method: 'GET',
    params: data
  });
};
export var deleteApi = function deleteApi(data) {
  return axiosRequest({
    url: '/web/Certificate/getTaskFailTotal',
    method: 'GET',
    params: data
  });
};